import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './PackageInfo.scss';

function PackageInfo({ children, iconSrc }) {
  return (
    <div className="package-info-popup-card">
      <div className="package-info-content">
        <Image src={iconSrc} alt="info icon" className="package-info-icon" />
        <div className="package-info-text-container">
          <div className="package-info-text">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PackageInfo;
